import React from 'react'
import { FormattedMessage } from 'react-intl'
import { reduxForm, Field } from 'redux-form'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Button,
  ButtonGroup
} from 'react-bootstrap'
import SelectedDocumentFolder from '../../SelectedDocumentFolder'

const FolderField = (field) => {
  return (
    <FormGroup>
      <ControlLabel><FormattedMessage id='DOCUMENT_FOLDER_SELECTED_SOURCE' /></ControlLabel>
      <SelectedDocumentFolder
        documentSourceId={field.input.value.documentSourceId}
        path={field.input.value.url}
      />
    </FormGroup>
  )
}

const NameField = (field) => {
  const onInputFocus = (event) => {
    const tempValue = event.target.value
    event.target.value = ''
    event.target.value = tempValue
  }

  return (
    <FormGroup
      validationState={field.meta.touched && field.meta.error ? 'error' : null}>
      <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
      <FormControl
        {...field.input}
        name={null}
        type='text'
        autoFocus
        onFocus={onInputFocus}
      />
      {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
    </FormGroup>
  )
}

const AddDocumentFolderForm = ({
  handleSubmit,
  submitting,
  onCancelClick,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name='folder'
        component={FolderField}
      />
      <Field
        name='name'
        component={NameField}
      />
      <ButtonGroup>
        <Button type='submit' bsStyle='primary' disabled={submitting}><FormattedMessage id='ADD' /></Button>
        <Button onClick={onCancelClick}><FormattedMessage id='CANCEL' /></Button>
      </ButtonGroup>
    </form>
  )
}

export default reduxForm({
  form: 'addDocumentFolder'
})(AddDocumentFolderForm)
